import React, { useRef } from 'react';
import { ContentPopup } from 'components/ContentPopup.jsx';
import { ADMIN_DISABLED_WARNING } from 'components/show_drawing/redraw_form/combo_constants.js';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';

const ComboTypePicker = ( { group, onSelect, onClose } ) => {
  const popupRef = useRef();

  const content = (
    <>
      <h4> {t(`drawing.combo_choose_${group.guest_name}`)} </h4>
      <ul className={styles.combo_picker_list}>
        {group.relations.map((relation) => (
          <li key={relation.id}>
            <button
              type="button"
              className={styles.combo_picker_item}
              onClick={() => onSelect(relation.id)}
            >
              {relation.guest_drawing.thumbnail_url && (
                <img
                  src={relation.guest_drawing.thumbnail_url}
                  alt=""
                  className={styles.combo_picker_thumbnail}
                />
              )}
              <span className={styles.combo_picker_label}>
                {relation.guest_drawing.catalog_name || relation.guest_drawing.friendly_name}
              </span>
              {relation.enabled === false && (
                <span className={styles.combo_admin_warning}>{ADMIN_DISABLED_WARNING}</span>
              )}
            </button>
          </li>
        ))}
      </ul>
    </>
  );

  return (
    <ContentPopup
      contextClass="wrapper"
      myRef={popupRef}
      autoOpen={true}
      content={content}
      cancelButton={true}
      beforeClose={onClose}
      notWide={true}
    />
  );
};

export default ComboTypePicker;
